import { format, getDay, parseISO } from 'date-fns';
import { isValidDate, isValidTime } from './agendamentoSeries';
import { firstName, whatsappNumber } from './birthdays';

// Mensagem do WhatsApp com a data e o horário dos agendamentos cadastrados.
// Trabalha só com textos 'yyyy-MM-dd' e 'HH:mm' (horário de parede, sem fuso), como a série.

const WEEK_DAY_NAMES = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];

const sessionOrder = (a, b) => `${a.date}${a.start_time}`.localeCompare(`${b.date}${b.start_time}`);

// Agora, no mesmo formato das sessões: 'yyyy-MM-ddTHH:mm'
export const nowText = () => format(new Date(), "yyyy-MM-dd'T'HH:mm");

// { date: '2026-10-14', start_time: '14:00' } -> 'quarta-feira, 14/10/2026, às 14:00' ("à" na 0h e na 1h)
export function sessionWhen(session) {
  const date = parseISO(session.date);
  const hour = Number(session.start_time.substring(0, 2));

  return `${WEEK_DAY_NAMES[getDay(date)]}, ${format(date, 'dd/MM/yyyy')}, ${hour <= 1 ? 'à' : 'às'} ${session.start_time}`;
}

// Sessões válidas, na ordem da data e do horário
const validSessions = (sessions) => (sessions ?? [])
  .filter((session) => isValidDate(session?.date) && isValidTime(session?.start_time))
  .sort(sessionOrder);

// Só o que ainda vai acontecer: o lote aceita datas passadas (com aviso), e elas não vão para o paciente
export const upcomingSessions = (sessions, now = nowText()) => validSessions(sessions).filter((session) => `${session.date}T${session.start_time}` >= now);

export function agendamentoWhatsappMessage(nome, sessions) {
  const list = validSessions(sessions);
  if (list.length === 0) return '';

  const name = firstName(nome);
  const greeting = name ? `Olá, ${name}!` : 'Olá!';

  if (list.length === 1) return `${greeting} Seu atendimento na *Ajust* está agendado para ${sessionWhen(list[0])}.`;

  // Uma linha em branco depois do cabeçalho e uma sessão por linha, com "* " (lista no WhatsApp)
  return [`${greeting} Seus ${list.length} atendimentos na *Ajust* estão agendados para:`, '', ...list.map((session) => `* ${sessionWhen(session)}`)].join('\n');
}

// Link do WhatsApp com a mensagem pronta, só com as sessões que ainda não passaram (sem nenhuma, null).
// Sem celular no cadastro, o WhatsApp pede o contato (wa.me/?text=)
export function agendamentoWhatsappLink(paciente, sessions, now = nowText()) {
  const message = agendamentoWhatsappMessage(paciente?.nome, upcomingSessions(sessions, now));
  if (!message) return null;

  const number = whatsappNumber(paciente);
  return `https://wa.me/${number ?? ''}?text=${encodeURIComponent(message)}`;
}
